import BotResponseTreeNode from './BotResponseTreeNode';

class SlotConditionalTreeNode {
  slotValue: string;

  nextStep: BotResponseTreeNode | null;

  constructor(slotValue: string, nextStep: BotResponseTreeNode | null) {
    this.slotValue = slotValue;
    this.nextStep = nextStep;
  }
}

export default SlotConditionalTreeNode;
